"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberCoder = void 0;

var _bignumber = require("@ethersproject/bignumber");

var _constants = require("@ethersproject/constants");

var _abstractCoder = require("./abstract-coder");

class NumberCoder extends _abstractCoder.Coder {
  constructor(size, signed, localName) {
    const name = (signed ? "int" : "uint") + size * 8;
    super(name, name, localName, false);
    this.size = size;
    this.signed = signed;
  }

  encode(writer, value) {
    let v = _bignumber.BigNumber.from(value); // Check bounds are safe for encoding


    let maxUintValue = _constants.MaxUint256.mask(writer.wordSize * 8);

    if (this.signed) {
      let bounds = maxUintValue.mask(this.size * 8 - 1);

      if (v.gt(bounds) || v.lt(bounds.add(_constants.One).mul(_constants.NegativeOne))) {
        this._throwError("value out-of-bounds", value);
      }
    } else if (v.lt(_constants.Zero) || v.gt(maxUintValue.mask(this.size * 8))) {
      this._throwError("value out-of-bounds", value);
    }

    v = v.toTwos(this.size * 8).mask(this.size * 8);

    if (this.signed) {
      v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
    }

    return writer.writeValue(v);
  }

  decode(reader) {
    let value = reader.readValue().mask(this.size * 8);

    if (this.signed) {
      value = value.fromTwos(this.size * 8);
    }

    return reader.coerce(this.name, value);
  }

}

exports.NumberCoder = NumberCoder;